module.exports = __webpack_public_path__ + "components/rewards/support/static/logo-05be4ed1b9818dc06da70b2581e7d3ea.jpg";